import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import { severityLevels, EventTypes, TripGernyEnum } from "../../config/app-globals.enum";
import L, { icon } from "leaflet";
import { getEventType } from "../../services/LocalStorageService";
import { getMapUrl } from "../../services/LocalStorageService";
import BreakingHigh from "../../assets/images/breaking-high.png";
import BreakingMedium from "../../assets/images/breaking-med.png";
import BreakingLow from "../../assets/images/breaking-low.png";
import CorneringHigh from "../../assets/images/cornering-high.png";
import CorneringMedium from "../../assets/images/cornering-med.png";
import CorneringLow from "../../assets/images/cornering-low.png";
import SpeedingHigh from "../../assets/images/speeding-high.png";
import SpeedingMedium from "../../assets/images/speeding-med.png";
import SpeedingLow from "../../assets/images/speeding-low.png";
import DistractionHigh from "../../assets/images/distraction-high.png";
import DistractionMedium from "../../assets/images/distraction-med.png";
import DistractionLow from "../../assets/images/distraction-low.png";
import AccelerationHigh from "../../assets/images/acceleration-high.png";
import AccelerationMedium from "../../assets/images/acceleration-med.png";
import AccelerationLow from "../../assets/images/acceleration-low.png";
import TripCircle from "../../assets/images/tripCircle.png"
import TripSquare from "../../assets/images/tripSquare.png"
import { getDriverMapPointsList } from "../../services/DriverTripMapPoints";
import { useTranslation } from "react-i18next";
import { useStyles } from "../../assets/jss/DriverLocator";
import CustomCard from "../../components/CustomComponents/CustomCard/CustomCard";
import CustomBox from "../../components/CustomComponents/CustomBox/CustomBox";
import DateTime from "../../components/DateTime/DateTime";
import ErrorAlert from '../../components/ErrorAlert/ErrorAlert';
import 'leaflet.markercluster';
// import { useHistory, useParams } from "react-router-dom";


export default function Map(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [isApiFailed, setIsApiFailed] = useState(false);
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const [locationData, setLocationData] = useState(null);
    const [mapUrl] = React.useState(getMapUrl);

    useEffect(() => {
        if (props.selectedTrip) {
            handleDriverClick(props.selectedTrip);
        }
    }, [props.selectedTrip])

    const handleDriverClick = async (param) => {
        if (param && param.tripId && param.userId) {
            setAlertMessage("");
            setIsAlertOpen(false);
            setLocationData(null);
            const data = await getDriverMapPointsList(param);
            if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content && data.content.tripLocationList && data.content.tripLocationList.length > 0) {
                if (data.content.tripLocationList && data.content.tripLocationList.length > 0) {
                    setLocationData(data.content);
                }
            } else {
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }
    }

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200 && status.code !== 201) {
            setStatusValue(status.code);
            setAlertMessage(status.message ? status.message : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`);
            setIsAlertOpen(true);
        }
    };

    function setIsMapInitialized() {
        props.setIsMapInitialized(true);
    }

    function DrawPolyline() {
        const { selectedTrip, selectedEvent } = props;
        const map = useMap();
        map.eachLayer(function (layer) {
            try {
                if (!!layer.toGeoJSON) {
                    map.removeLayer(layer);
                }
            } catch (error) {
                console.warn(error)
            }
        });
        if (!selectedTrip) {
            // map.setZoom(6);
            return null
        }
        if (!selectedTrip.startLatitude && !selectedTrip.startLongitude && !selectedTrip.endLatitude && !selectedTrip.endLongitude) {
            return null;
        }
        if (!selectedTrip.startLatitude && !selectedTrip.startLongitude && selectedTrip.endLatitude && selectedTrip.endLongitude) {
            selectedTrip.startLatitude = selectedTrip.endLatitude;
            selectedTrip.startLongitude = selectedTrip.endLongitude;
        } else if (selectedTrip.startLatitude && selectedTrip.startLongitude && !selectedTrip.endLatitude && !selectedTrip.endLongitude) {
            selectedTrip.endLatitude = selectedTrip.startLatitude;
            selectedTrip.endLongitude = selectedTrip.startLongitude;
        }

        /**Add circle to trip start point */
        function DrawCircle(location) {
            try {
                const markerIcon = new L.Icon({
                    iconUrl: TripCircle,
                    iconRetinaUrl: TripCircle,
                    // iconAnchor: null,
                    // popupAnchor: null,
                    shadowUrl: null,
                    shadowSize: null,
                    shadowAnchor: null,
                    iconSize: new L.Point(10, 10),
                    className: "",
                });
                var newMarker = new L.marker([location.latitude, location.longitude], { icon: markerIcon, eventData: location }).on('click', setSelectedEvent);
                return newMarker;
            } catch (error) {
                console.log(error);
            }
            return null;
        }
        /**Add square to trip end point */
        function DrawSquare(location) {
            try {
                const markerIcon = new L.Icon({
                    iconUrl: TripSquare,
                    iconRetinaUrl: TripSquare,
                    iconAnchor: null,
                    popupAnchor: null,
                    shadowUrl: null,
                    shadowSize: null,
                    shadowAnchor: null,
                    iconSize: new L.Point(10, 10),
                    className: "",
                });
                var newMarker = new L.marker([location.latitude, location.longitude], { icon: markerIcon, eventData: location }).on('click', setSelectedEvent);
                return newMarker;
            } catch (error) {
                console.log(error);
            }
            return null;
        }

        /**Get image icon as per event type & its severity */
        function GetIconUrl(eventData) {
            const [eventTypes] = React.useState(getEventType);
            try {
                /**Get eventType */
                if (eventTypes && eventTypes.length > 0) {
                    var eventTypeData = eventTypes.find(
                        (el) => el.id === eventData.eventTypeId
                    );
                    if (eventTypeData) {
                        if ((eventTypeData.parentEventTypeId && eventTypeData.parentEventTypeId == EventTypes.BRAKING) || eventTypeData.id == EventTypes.BRAKING) {
                            /**Check severity of event */
                            if (eventData.severity === severityLevels.WARNING || eventData.severity === severityLevels.NONE) {
                                return BreakingLow;
                            } else if (eventData.severity === severityLevels.ALERT) {
                                return BreakingMedium;
                            } else if (eventData.severity === severityLevels.SEVER) {
                                return BreakingHigh
                            }
                        } else if ((eventTypeData.parentEventTypeId && eventTypeData.parentEventTypeId == EventTypes.CORNERING) || eventTypeData.id == EventTypes.CORNERING) {
                            /**Check severity of event */
                            if (eventData.severity === severityLevels.WARNING || eventData.severity === severityLevels.NONE) {
                                return CorneringLow;
                            } else if (eventData.severity === severityLevels.ALERT) {
                                return CorneringMedium;
                            } else if (eventData.severity === severityLevels.SEVER) {
                                return CorneringHigh;
                            }
                        } else if ((eventTypeData.parentEventTypeId && eventTypeData.parentEventTypeId == EventTypes.SPEEDING) || eventTypeData.id == EventTypes.SPEEDING) {
                            /**Check severity of event */
                            if (eventData.severity === severityLevels.WARNING || eventData.severity === severityLevels.NONE) {
                                return SpeedingLow;
                            } else if (eventData.severity === severityLevels.ALERT) {
                                return SpeedingMedium;
                            } else if (eventData.severity === severityLevels.SEVER) {
                                return SpeedingHigh;
                            }
                        } else if ((eventTypeData.parentEventTypeId && eventTypeData.parentEventTypeId == EventTypes.DISTRACTION) || eventTypeData.id == EventTypes.DISTRACTION) {
                            /**Check severity of event */
                            if (eventData.severity === severityLevels.WARNING || eventData.severity === severityLevels.NONE) {
                                return DistractionLow;
                            } else if (eventData.severity === severityLevels.ALERT) {
                                return DistractionMedium;
                            } else if (eventData.severity === severityLevels.SEVER) {
                                return DistractionHigh;
                            }
                        } else if ((eventTypeData.parentEventTypeId && eventTypeData.parentEventTypeId == EventTypes.ACCELERATION) || eventTypeData.id == EventTypes.ACCELERATION) {
                            /**Check severity of event */
                            if (eventData.severity === severityLevels.WARNING || eventData.severity === severityLevels.NONE) {
                                return AccelerationLow;
                            } else if (eventData.severity === severityLevels.ALERT) {
                                return AccelerationMedium;
                            } else if (eventData.severity === severityLevels.SEVER) {
                                return AccelerationHigh;
                            }
                        }
                    }
                }

            } catch (error) {
                console.log(error);
            }
        }

        function setSelectedEvent(e) {
            var marker = e.target;
            props.setSelectedEvent(marker.options.eventData);
        }

        /**Add Event marker & event path on map */
        function AddEventMarkerAndPath(eventData) {
            try {
                /**Get event marker icon */
                const iconUrl = GetIconUrl(eventData);
                const markerIcon = new L.Icon({
                    iconUrl: iconUrl,
                    iconRetinaUrl: iconUrl,
                    iconAnchor: null,
                    popupAnchor: null,
                    shadowUrl: null,
                    shadowSize: null,
                    shadowAnchor: null,
                    iconSize: new L.Point(20, 27),
                    className: "",
                });
                var newMarker = null;
                /**Add event marker */
                if (eventData) {
                    if (eventData.startLatitude && eventData.startLongitude) {
                        newMarker = new L.marker([eventData.startLatitude, eventData.startLongitude], { icon: markerIcon, eventData: eventData, draggable: false }).addTo(map).on('click', setSelectedEvent);
                    } else if (eventData.endLatitude && eventData.endLongitude) {
                        newMarker = new L.marker([eventData.endLatitude, eventData.endLongitude], { icon: markerIcon, eventData: eventData, draggable: false }).addTo(map).on('click', setSelectedEvent);
                    } else {
                        newMarker = new L.marker([selectedTrip.startLatitude, selectedTrip.startLongitude], { icon: markerIcon, eventData: eventData, draggable: false }).addTo(map).on('click', setSelectedEvent);
                    }
                }
                /**Add event path if event is sever */
                if (eventData.severity === severityLevels.SEVER) {
                    if (locationData && locationData.eventLocationList && locationData.eventLocationList.length > 0) {
                        let eventMapData = locationData.eventLocationList.find((el) => el.eventId === eventData.eventId);
                        if (eventMapData && eventMapData.eventLocationList && eventMapData.eventLocationList.length > 0) {
                            var eventPointList = new Array();
                            for (let j = 0; j < eventMapData.eventLocationList.length; j++) {
                                try {
                                    let eventMapPoint = eventMapData.eventLocationList[j];
                                    if (eventMapPoint) {
                                        var point = new L.LatLng(eventMapPoint.latitude, eventMapPoint.longitude);
                                        eventPointList.push(point);
                                    }
                                } catch (error) {
                                    console.warn(error);
                                }
                            }
                            /**Draw polyline for event on map */
                            var eventPolyline = L.polyline(eventPointList, {
                                color: "red",
                            }).addTo(map);
                        }
                    }
                }
                return newMarker;
            } catch (error) {
                console.log(error);
            }
            return null;
        }

        try {
            var markers = L.markerClusterGroup({
                iconCreateFunction: function (cluster) {
                    return L.divIcon({ className: classes.mapDivIcon, html: `<div class=${classes.mapClusterIconClass}><span>${cluster.getChildCount()}</span></div>` });
                },
                spiderfyShapePositions: function (count, centerPt) {
                    var distanceFromCenter = 35,
                        markerDistance = 45,
                        lineLength = markerDistance * (count - 1),
                        lineStart = centerPt.y - lineLength / 2,
                        res = [],
                        i;

                    res.length = count;

                    for (i = count - 1; i >= 0; i--) {
                        try {
                            res[i] = new L.Point(centerPt.x + distanceFromCenter, lineStart + markerDistance * i);
                        } catch (error) {
                            console.warn(error)
                        }
                    }

                    return res;
                }
            });
            /**Collect map points to draw polyline for trip */
            var pointList = new Array();
            /**Add circle to trip start point */
            let startPoint: any = {};
            startPoint.startAddress = props.selectedTrip.startAddress;
            startPoint.endAddress = props.selectedTrip.endAddress;
            startPoint.startLatitude = props.selectedTrip.startLatitude;
            startPoint.startLongitude = props.selectedTrip.startLongitude;
            startPoint.endLatitude = props.selectedTrip.endLatitude;
            startPoint.endLongitude = props.selectedTrip.endLongitude;
            startPoint.startTime = props.selectedTrip.startTime;
            startPoint.endTime = props.selectedTrip.endTime;
            startPoint.tripPoint = TripGernyEnum.TRIP_START;
            startPoint.latitude = props.selectedTrip.startLatitude;
            startPoint.longitude = props.selectedTrip.startLongitude;
            let startMarker = DrawCircle(startPoint);
            if (startMarker !== null)
                markers.addLayer(startMarker);
            var tripStartPoint = new L.LatLng(props.selectedTrip.startLatitude, props.selectedTrip.startLongitude);
            pointList.push(tripStartPoint);
            if (locationData && locationData.tripLocationList) {
                for (let i = 0; i < locationData.tripLocationList.length; i++) {
                    try {
                        let location = locationData.tripLocationList[i];
                        if (location && location.latitude && location.longitude) {
                            // location.startAddress = props.selectedTrip.startAddress;
                            // location.endAddress = props.selectedTrip.endAddress;
                            // location.startLatitude = props.selectedTrip.startLatitude;
                            // location.startLongitude = props.selectedTrip.startLongitude;
                            // location.endLatitude = props.selectedTrip.endLatitude;
                            // location.endLongitude = props.selectedTrip.endLongitude;
                            // location.startTime = props.selectedTrip.startTime;
                            // location.endTime = props.selectedTrip.endTime;
                            // location.tripData = props.selectedTrip;
                            // /**Add circle to trip start point */
                            // if (i === 0) {
                            //     location.tripPoint = TripGernyEnum.TRIP_START;
                            //     DrawCircle(location);
                            // }
                            // /**Add square to trip end point */
                            // if (i === locationData.tripLocationList.length - 1) {
                            //     location.tripPoint = TripGernyEnum.TRIP_END;
                            //     DrawSquare(location);
                            // }
                            var point = new L.LatLng(location.latitude, location.longitude);
                            pointList.push(point);
                        }
                    } catch (error) {
                        console.warn(error)
                    }
                }
            }
            /**Add square to trip end point */
            let endPoint: any = {};
            endPoint.startAddress = props.selectedTrip.startAddress;
            endPoint.endAddress = props.selectedTrip.endAddress;
            endPoint.startLatitude = props.selectedTrip.startLatitude;
            endPoint.startLongitude = props.selectedTrip.startLongitude;
            endPoint.endLatitude = props.selectedTrip.endLatitude;
            endPoint.endLongitude = props.selectedTrip.endLongitude;
            endPoint.startTime = props.selectedTrip.startTime;
            endPoint.endTime = props.selectedTrip.endTime;
            endPoint.tripPoint = TripGernyEnum.TRIP_END;
            endPoint.latitude = props.selectedTrip.endLatitude;
            endPoint.longitude = props.selectedTrip.endLongitude;
            let endMarker = DrawSquare(endPoint);
            if (endMarker !== null)
                markers.addLayer(endMarker);
            map.addLayer(markers);
            var tripEndPoint = new L.LatLng(props.selectedTrip.endLatitude, props.selectedTrip.endLongitude);
            pointList.push(tripEndPoint);
            let polyline = null;
            if (pointList && pointList.length > 0) {
                /**Move to trip path */
                map.flyTo({ lat: startPoint.latitude, lng: startPoint.longitude, }, 13, { animated: false });
                /**Draw polyline on map */
                polyline = L.polyline(pointList, { color: "black" }).addTo(map);
            }
            /**Get events & add marker for each event */
            if (selectedTrip && selectedTrip.eventList && selectedTrip.eventList.length > 0) {
                var markers = L.markerClusterGroup({
                    iconCreateFunction: function (cluster) {
                        return L.divIcon({ className: classes.mapDivIcon, html: `<div class=${classes.mapClusterIconClass}><span>${cluster.getChildCount()}</span></div>` });
                    },
                    spiderfyShapePositions: function (count, centerPt) {
                        var distanceFromCenter = 35,
                            markerDistance = 45,
                            lineLength = markerDistance * (count - 1),
                            lineStart = centerPt.y - lineLength / 2,
                            res = [],
                            i;

                        res.length = count;

                        for (i = count - 1; i >= 0; i--) {
                            try {
                                res[i] = new L.Point(centerPt.x + distanceFromCenter, lineStart + markerDistance * i);
                            } catch (error) {
                                console.warn(error);
                            }
                        }

                        return res;
                    }
                });
                for (let i = 0; i < selectedTrip.eventList.length; i++) {
                    try {
                        let eventData = selectedTrip.eventList[i];
                        if (eventData) {
                            let newMarker = null;
                            if (selectedEvent) {
                                if (selectedEvent.eventId === eventData.eventId) {
                                    newMarker = AddEventMarkerAndPath(eventData);
                                    break;
                                }
                            } else {
                                newMarker = AddEventMarkerAndPath(eventData);
                            }
                            if (newMarker !== null) {
                                markers.addLayer(newMarker);
                            }
                        }
                    } catch (error) {
                        console.warn(error)
                    }
                }
                map.addLayer(markers);
            }
            let latlngBounds = L.latLngBounds(pointList);
            map.flyToBounds(latlngBounds, { padding: L.point(36, 36), animate: false });
        } catch (error) {
            console.log(error);
        }

        return null;
    }
    return (
        <>
            <link rel="stylesheet" href="https://unpkg.com/leaflet@1.4.0/dist/leaflet.css" />
            <MapContainer zoomControl={false} center={[51.5, 0.12]} zoom={6} style={{ width: "100%", height: "100%" }} >
                <TileLayer url={mapUrl} />
                <DrawPolyline />
            </MapContainer>
        </>
    );
}